import { render } from "./my-notifications.vue?vue&type=template&id=74719e8f&scoped=true"
import script from "./my-notifications.vue?vue&type=script&lang=js"
export * from "./my-notifications.vue?vue&type=script&lang=js"

import "./my-notifications.vue?vue&type=style&index=0&id=74719e8f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74719e8f"]])

export default __exports__